<div class="row justify-content-md-center">
  <div class="col-sm-12 col-md-6 col-md-auto">

    <!-- Sign In -->
    <div class="sign__container">

      <div style="margin-bottom: 30px; text-align: center;">
        <a href="http://www.telego.com/" style="box-sizing: border-box; color: #2196F3; text-decoration: none;">
          <img alt="TeleGo" style="-ms-interpolation-mode: bicubic; max-width: 100%;"
               src="../../../assets/images/logo-with-slogan.svg">
        </a>
      </div>

      <div class="card card-default">

        <div class="card-body">
          <h4 class="card-title">Log in to Your Account</h4>
          <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="serverError">
            {{serverMessage}}
          </div>
        </div> <!-- / .panel-body -->

      </div> <!-- / .card -->

      <p class="sign__extra text-muted text-center" style="font-size: 15px;">
        Try again? <a routerLink="{{loginUrl}}" style="font-size: 19px;">Sign In</a>.
      </p>

    </div> <!-- / .sign__conteiner -->

  </div>
</div>
